module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9XFFp8/media/FC-9781649791443.jpg?1684514527483",
      "alt": "This image is the cover for the book A Detective from Small Town America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Detective from Small Town America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0mm",
      "margin-right": "0mm",
      "margin-bottom": "8.0pt",
      "margin-left": "0mm",
      "font-size": "15px",
      "font-family": "\"Calibri\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("If you would like to put a little excitement in your life, come along for the ride! The detective stories in this book will give you a thrill and a smile. When I started my journey through life, through the eyes of a private detective, I started seeing the world in a different way. My detective stories shared in this book show the good, the bad, and the ugly of the American society. You, as the reader, can judge how the good got good and how the bad got bad. There is a saying that you can’t judge a book by its cover; as a private detective, you can’t judge people by their appearance, but it does seem that sometimes you can find the good in most people, even in the fast lane…")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gabe Kemling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "windowtext"
    }
  }, [_vm._v("My name is Gaylord ‘Gabe’ Kemling. I was a licensed Wisconsin private detective; or called a Wisconsin private eye. I worked for and with Steve Brickman who owned a detective agency that was licensed in Wisconsin for years. The agency shut down in March of 2016 when Steve Brickman passed away. His death was very hard on me.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "windowtext"
    }
  }, [_vm._v("During the partnership of doing investigations over the years, Steve and I occasionally, after a day’s work was done, would sit down and write about that day’s investigation work, if it was worth writing about. We could complete the story, type it out, edit it and then preserve the story for future use. We usually did all this work throughout the night, but sometimes would wait until the next morning.")])]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "0cm",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif",
      "color": "black",
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "windowtext"
    }
  }, [_vm._v("These are real detective stories that Steve and I worked together on over the years. When at times we met the good, bad, and the ugly.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0